import { render, staticRenderFns } from "./ModalHeaderV2.vue?vue&type=template&id=92716104&scoped=true&"
import script from "./ModalHeaderV2.vue?vue&type=script&lang=js&"
export * from "./ModalHeaderV2.vue?vue&type=script&lang=js&"
import style0 from "./ModalHeaderV2.vue?vue&type=style&index=0&id=92716104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92716104",
  null
  
)

export default component.exports